import React, { createContext, useContext, useCallback } from 'react';
import apiService from '../services/api.service';

export const ActivityContext = createContext();

export const ACTIVITY_TYPES = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  VIEW: 'VIEW',
  UPLOAD: 'UPLOAD',
  RENDERER_ACTION: 'RENDERER_ACTION'
};

export const RESOURCE_TYPES = {
  USER: 'user',
  SCENE: 'scene',
  RENDERER: 'renderer',
  ASSET: 'asset',
  ORGANIZATION: 'organization'
};

export const ActivityProvider = ({ children }) => {
  const trackActivity = useCallback((
    activityType,
    resourceType = null,
    resourceId = null,
    resourceName = null,
    additionalDetails = {}
  ) => {
    try {
      const storedUserData = localStorage.getItem("userData");
      if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        const userId = userData?.data?._id;
        const userName = userData?.data?.user_name;
        const organizationId = userData?.data?.organization_id?._id;
        setTimeout(() => {
          apiService.createActivityLog({
            user_id: userId,
            user_name: userName,
            organization_id: organizationId,
            activity_type: activityType,
            resource_type: resourceType,
            resource_id: resourceId,
            resource_name: resourceName,
            ...additionalDetails
          }).catch((err) => console.error('Activity log failed:', err));
        }, 0);
      }
    } catch (e) {
      // Don't block or throw; activity is non-critical
    }
  }, []);

  return (
    <ActivityContext.Provider value={{ 
      trackActivity, 
      ACTIVITY_TYPES,
      RESOURCE_TYPES
    }}>
      {children}
    </ActivityContext.Provider>
  );
};

export const useActivity = () => {
  const context = useContext(ActivityContext);
  if (!context) {
    throw new Error('useActivity must be used within an ActivityProvider');
  }
  return context;
};